module.exports = __webpack_public_path__ + "img/tom.264d56cb.jpg";